import styled, { keyframes } from 'styled-components'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { BaseButton, Box, Flex, FlexProps } from 'vvs-uikit'

export const GachaponModalFlex = styled(Flex)<{ grassBg?: boolean }>`
  position: relative;
  ${({ theme, grassBg: mintBg }) =>
    mintBg
      ? `
    background-image: url('/images/vvsGotchi/bg_grass.png');
    background-position: bottom;
    background-size: cover;
  `
      : `
    background: ${theme.colors.paleYellow};
  `};
  border-radius: 18px;
  border: 3px solid black;
  z-index: ${({ theme }) => theme.zIndices.modal};
  max-height: 100vh;
  max-width: 345px;
  flex-direction: column;
`

export const ModalTitleFlex = styled(Flex)<{ bg: 'grass' | 'yellow'; bottomLine?: boolean }>`
  ${({ bg, theme }) =>
    bg === 'grass'
      ? `
    background-image: url('/images/vvsGotchi/bg_grass.png');
    background-position: center;
    background-size: cover;
  `
      : `
    background: ${theme.colors.warningLight};
  `}
  flex: 1;
  flex-direction: column;
  border-radius: 14px 14px 0 0;
  ${({ bottomLine }) =>
    bottomLine &&
    `
    border-bottom: 3px solid black;
  `}
`

export const ModalTitleIcon = styled(PixelatedImage)`
  width: 62px;
  margin-top: -76px;
  align-self: center;
`

export const ModalCloseButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`

export const CountdownLabel = styled(Flex)`
  padding: 2px 9px 3px;
  margin-bottom: 2px;
  background-color: black;
  border-radius: 50px;
`

export const TaskButton = styled(BaseButton)<{ isCompleted: boolean }>`
  flex: 1;
  position: relative
  background-color: ${({ theme, isCompleted }) =>
    isCompleted ? theme.colors.gotchiSuccessLighterGreen : theme.colors.white};
  border: 3px solid ${({ theme, isCompleted }) =>
    isCompleted ? theme.colors.gotchiSuccessGreen : theme.colors.darkestNightBlue};
  border-radius: 12px;
  transform: translate(0, 0);
  box-shadow: 4px 6px 0 #00000026;
  padding: 12px;
  gap: 6px;
  transition: transform 0.2s, box-shadow 0.2s;

  &:not(:disabled) {
    cursor: pointer;
    &:hover {
      transform: translate(-2px, -2px);
      box-shadow: 6px 8px 0 #00000026;
    }
    &:active {
      transform: translate(2px, 2px);
      box-shadow: 2px 4px 0 #00000026;
    }
  }
`

export const TaskStatusLabel = styled(Flex)<{ type: 'completed' | 'pending' }>`
  position: absolute;
  top: -12px;
  right: -7px;
  background-color: ${({ theme, type }) =>
    type === 'completed' ? theme.colors.gotchiSuccessGreen : theme.colors.black};
  padding: 6px 8px;
  border-radius: 8px;
`

export const GachaponCtaButton = styled(BaseButton)`
  position: relative;
  background-position: center;
  background-size: cover;
  border-width: 3px;
  border-style: solid;
  align-self: stretch;
  border-radius: 12px;

  background-image: url('/images/vvsGotchi/bg_gray.png');
  border-color: ${({ theme }) => theme.colors.darkestNightBlue};
  &:not(:disabled) {
    cursor: pointer;
    background-image: url('/images/vvsGotchi/bg_grass.png');
    border-color: ${({ theme }) => theme.colors.darkGrey};
  }
`

export const GachaponSelectionButton = styled(BaseButton)`
  flex: 1;

  cursor: pointer;
  transform: scale(1, 1);
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.2, 1.2);
  }
  &:active {
    transform: scale(0.9, 0.9);
  }
`

export const GachaponBackground = styled(Box)<{ show?: boolean }>`
  z-index: ${({ theme }) => theme.zIndices.modal};
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-image: url('/images/vvsGotchi/bg_violet_red.png');
  background-size: auto 100%;

  transition: 500ms opacity;
  ${({ show }) =>
    show
      ? `
    opacity: 1;
  `
      : `
    opacity: 0;
    pointer-events: none;
  `}
`

export const AnimationContainer = styled(Flex)<{ bg?: string | null; aspect: string } & FlexProps>`
  aspect-ratio: ${({ aspect }) => aspect};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  justify-content: center;
  align-items: center;
  ${({ bg }) =>
    bg &&
    `
    background-image: url('${bg}');
  `}
`

export const AnimatedPixelatedImage = styled(PixelatedImage)<{ show?: boolean }>`
  ${({ show }) =>
    show
      ? `
    opacity: 1;
  `
      : `
    opacity: 0;
  `}
`

export const ZOOM_IN_ANIMATION_DURATION = 1000
const zoomIn = keyframes`
  from {
    transform: scale(0, 0);
  }
  to {
    transform: scale(1, 1);
  }
`
export const RollingContainer = styled(AnimationContainer)`
  position: absolute;
  width: 90vw;
  ${({ theme }) => theme.mediaQueries.xs} {
    width: 345px;
  }
  z-index: ${({ theme }) => theme.zIndices.modal};
  animation: ${zoomIn} ${ZOOM_IN_ANIMATION_DURATION}ms;
`

const slideDown = keyframes`
  from {
    transform: translate(0, -100vh);
  }
  to {
    transform: translate(0, 0);
  }
`
export const GachaponResultModalFlex = styled(GachaponModalFlex)`
  animation: ${slideDown} 1000ms cubic-bezier(0.25, 0.25, 0.315, 1.315);
`
